<template>
  <div class="public-content balance-enquiry-detail">
    <div class="breadcrumb">余额查询</div>
    <div class="right-main">
      <!--      查询订单-->
      <el-form :inline="true" ref="formName" :model="formInline" :rules="rules" label-width="100px" class="demo-form-inline">
        <el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item label="业务:">
                <el-select clearable v-model.trim="formInline.salesmanId" :filter-method="selectSalemanList" filterable placeholder="请输入业务名称">
                  <el-option v-for="item in salemanList" :key="item.id" :label="item.fullName" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="平台号:">
                <el-select clearable v-model.trim="formInline.storeId" :filter-method="filterMethod" filterable placeholder="请输入平台号">
                  <el-option v-for="item in storeListByCode" :key="item.id" :label="item.code" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="平台名称:">
                <el-select clearable v-model.trim="formInline.storeId" :filter-method="filterByName" filterable placeholder="请输入平台名称">
                  <el-option v-for="item in storeListByCode" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="余额小于:" prop="minBalanceLine">
                <el-input v-model="formInline.minBalanceLine" placeholder="请输入额度" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="授信额度大于:" prop="maxCreditLine">
                <el-input v-model="formInline.maxCreditLine" placeholder="请输入额度" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="当前告急额度:">
                <span>￥{{ warningLine }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="当前起充额度:">
                <span>￥{{ chargeLine }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6" class="fn-right form-btn">
              <el-button class="search-ok" type="primary" @click="lineType = 'WARNING_LINE_ACCOUNT', lineDialog = true, setCreditLine.line = warningLine" round style="min-width: auto !important;"
                v-if="$hasPermission('epay:admin:config:update')" v-permission="'epay:admin:config:update'">设置告急额度</el-button>
              <el-button class="search-ok" type="primary" @click="lineType = 'WARNING_LINE_CHARGE', lineDialog = true, setCreditLine.line = chargeLine" round style="min-width: auto !important;"
                v-if="$hasPermission('epay:admin:config:update')" v-permission="'epay:admin:config:update'">设置起充额度 </el-button>
              <el-button class="search-ok" @click="queryInfo.pageNum = 0; onSubmit()" round>查询</el-button>
              <el-button class="search-ok" @click="exportExcel" round>导出Excel</el-button>
            </el-col>
          </el-row>
        </el-row>
      </el-form>
      <div class="data-list">
        <el-table :data="tableData" :row-class-name="rowClassName" border style="width: 100%" fit>
          <el-table-column prop="store.code" label="平台号" min-width="100"></el-table-column>
          <el-table-column prop="store.name" label="平台名称" min-width="100"></el-table-column>
          <el-table-column prop="store.salesman.fullName" label="业务" min-width="100"></el-table-column>
          <el-table-column prop="balances.ACCT.balance" label="充值余额" min-width="100"></el-table-column>
          <el-table-column prop="balances.SETTLE.balance" label="结算余额" min-width="100">
            <template slot-scope="scope">{{ Math.floor(scope.row.balances.SETTLE.balance * 100) / 100 }}</template>
          </el-table-column>
          <el-table-column prop="balances.BONUS.balance" label="礼金券" min-width="100"></el-table-column>
          <!-- <el-table-column prop="balances.BONUS.balance" label="赠送余额" min-width="100"></el-table-column> -->
          <!-- <el-table-column prop="balances.VPAY_ACCOUNT.balance" label="当前余额" min-width="100"></el-table-column> -->
          <el-table-column prop="balances.ACCT.chargeGrandTotal" label="累计充值" min-width="100"></el-table-column>
          <el-table-column label="最后消费时间" min-width="100">
            <template slot-scope="scope">{{ $moment(scope.row.balances.BONUS.lastDateTraded).format('YYYY-MM-DD') }}</template>
          </el-table-column>
          <el-table-column label="授信额度" min-width="100">
            <template slot-scope="scope">{{ scope.row.standbyCreditLine }}</template>
          </el-table-column>
          <el-table-column label="操作" min-width="150">
            <template v-slot="scope">
              <span class="color-blue" @click="getStatus('余额明细', scope.row)" v-if="$hasPermission('epay:admin:vpayTrade:list')" v-permission="'epay:admin:vpayTrade:list'">余额明细<br></span>
              <span class="color-blue" v-permission="'epay:admin:account:creditLine'" v-if="$hasPermission('epay:admin:account:creditLine')" @click="getStatus('更改授信额度', scope.row)">更改授信额度<br></span>
              <span class="color-blue" @click="getStatus('提现', scope.row)" style="padding:0 5px;"
                v-show="$hasPermission('epay:admin:cashout:add') && scope.row.store.enabledVip && scope.row.balances.SETTLE.balance > 0">提现</span>
              <span class="color-blue" v-if="$hasPermission('epay:admin:refund:offadd')" @click="getStatus('线下退款', scope.row)">线下退款</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--    分页-->
      <!-- <v-pagination class="v-pagination" @changePage="changePage" :queryInfo='queryInfo'></v-pagination> -->
      <div class="vm-pagination">
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pageNum + 1" :page-size="queryInfo.pageSize"
          layout="prev, pager, next, jumper" :total="queryInfo.total">
        </el-pagination>
      </div>
    </div>
    <CombinedDialog ref="dialogRef" @updateWarningLine="getWarningLine" @changeRemark="changelimit"></CombinedDialog>
    <!-- 更改授信额度 -->
    <el-dialog :close-on-click-modal="false" title="更改授信额度" :visible.sync="dialogVisible" width="30%">
      <!-- <span>授信额度:</span> -->
      <el-form :label-position="labelPosition" ref="formSetCreditLine" :model="setCreditLine" :rules="rulesSetCreditLine">
        <el-form-item label="授信额度:" prop="setCreditLine">
          <el-input v-model.number="setCreditLine.setCreditLine" validate-event style="width:200px;margin-left:20px" placeholder="" clearable></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false, setCreditLine.setCreditLine = ''">取 消</el-button>
        <el-button type="primary" @click="setLine">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 更改额度 -->
    <el-dialog :close-on-click-modal="false" @close="setCreditLine.line = ''" :title="lineType === 'WARNING_LINE_CHARGE' ? '更改起充额度' : '更改告急额度'" :visible.sync="lineDialog" width="30%">
      <el-form :label-position="labelPosition" ref="formSetCreditLine" :model="setCreditLine" :rules="rulesSetCreditLine">
        <el-form-item :label="lineType === 'WARNING_LINE_CHARGE' ? '起充额度: ' : '告急额度: '" prop="line">
          <!-- validate-event属性的作用是: 输入时不触发表单验证.提交时再验证,你也可以设置成动态验证 -->
          <el-input v-model.number="setCreditLine.line" validate-event style="width:200px;margin-left:20px" placeholder="" clearable></el-input>
        </el-form-item>
      </el-form>
      <!-- <span>{{ lineType === 'WARNING_LINE_CHARGE' ? '起充额度:' : '告急额度:' }}</span>
      <el-input v-model="line" style="width:200px;margin-left:20px" placeholder=""></el-input> -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="lineDialog = false, setCreditLine.line = ''">取 消</el-button>
        <el-button type="primary" @click="updataLine">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 线下退款 -->
    <el-dialog :close-on-click-modal="false" title="线下退款" :visible.sync="OffDialog" width="30%" @close="OffDialogCancel">
      <el-form :label-position="labelPosition" ref="formNames" label-width="160px" :model="formLabelAlign" :rules="rulesLabelAlign">
        <el-form-item label="当前余额:"> {{ formLabelAlign.ACCT }} </el-form-item>
        <el-form-item label="当前礼金券:"> {{ formLabelAlign.BONUS }} </el-form-item>
        <el-form-item label="退款金额:" prop="amount">
          <el-input v-model="formLabelAlign.amount" style="width:100%" clearable></el-input>
        </el-form-item>
        <el-form-item label="清空礼金券额度:" prop="clearQuota">
          <!-- <el-input v-model="formLabelAlign.clearQuota" style="width:100%;" clearable></el-input> --> {{ formLabelAlign.BONUS }} </el-form-item>
        <el-form-item label="备注:" prop="remark">
          <el-input v-model.trim="formLabelAlign.remark" type="textarea" :rows="2" placeholder="请输入内容" style="width:100%" clearable></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="OffDialogCancel">取 消</el-button>
        <el-button type="primary" @click="setOff" :loading="loading">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 信息提示 -->
    <el-dialog :close-on-click-modal="false" title="信息提示" :visible.sync="tipDialog" width="30%">
      <span>清空礼金券大于当前礼金券，请修改后提交。</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="tipDialog = false">取 消</el-button>
        <el-button type="primary" @click="tipDialog = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
// import VPagination from '@/components/Pagination/index.vue'
import CombinedDialog from '@/components/Dialog/CombinedDialog/index'
import store from '@/store/index'
import { getPlatListBySaleman, accountWarningLineGet, accountSetCreditLine, accountExport, adminConfigGet, adminConfigUpdate, addRefund } from '@/api/epay'
import { storeQueryListByCode, storeQueryListByName, getSalesmanByFullName } from '@/api/crm'
import { refundExport } from '../../api/refund'
export default {
  name: 'VpayAccount',
  components: {
    // VPagination,
    CombinedDialog
  },
  inject: ['reload'],
  data () {
    var minBalanceLine = (rule, value, callback) => {
      // if (value && !/^([0-9]+[\d]*(.[0-9]{1,2})?)$/.test(value)) {
      if (value && !/^-?[1-9]\d*|0$/.test(value)) {
        callback(new Error('请输入正确的金额'))
      } else {
        callback()
      }
    }
    var maxCreditLine = (rule, value, callback) => {
      console.log(value, '授信额度')
      // if (value && !/^([0-9]+[\d]*(.[0-9]{1,2})?)$/.test(value)) {
      // 整数
      if (value && !/^-?[1-9]\d*|0$/.test(value)) {
        callback(new Error('请输入正确的金额'))
      } else {
        callback()
      }
    }
    // 校验金额
    var checkAmount = (rule, value, callback) => {
      // const regAmount = /^[1-9]\d*$/
      const regAmount = /^(?!0+(?:\.0+)?$)(?:[1-9]\d*|0)(?:\.\d{1,2})?$/
      if (value === '') {
        callback(new Error('请输入金额'))
      } else if (regAmount.test(value)) {
        return callback()
      } else {
        // callback(new Error('请输入正整数(不包括0)'))
        callback(new Error('请输入正数且小数点后精度两位'))
      }
    }
    var checkClearQuota = (rule, value, callback) => {
      // const regAmount = /^[1-9]\d*$/
      const regAmount = /^(?!(?:\.0+)?$)(?:[1-9]\d*|0)(?:\.\d{1,2})?$/
      if (value === '') {
        callback(new Error('请输入积分'))
      } else if (regAmount.test(value)) {
        return callback()
      } else {
        // callback(new Error('请输入正整数(不包括0)'))
        callback(new Error('请输入正数且小数点后精度两位'))
      }
    }
    /* 数字类型，大于0的正整数 */
    var setCreditLine = (rule, value, callback) => {
      // if (value && !/^[0-9]*[1-9][0-9]*$/.test(value)) {
      // 大于等于0的正整数 
      if (value && !/^(0|[1-9][0-9]*)$/.test(value)) {
        callback(new Error('请输入正确的金额'))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      formLabelAlign: {
        ACCT: '', // 当前余额
        BONUS: '', // 赠送余额
        amount: '', // 退款金额
        clearQuota: '', // 清空赠送余额
        remark: '', // 备注
        storeId: ''
      },
      rulesLabelAlign: {
        amount: [
          { required: true, validator: checkAmount, trigger: 'change' }
        ],
        // clearQuota: [
        //   { required: true, validator: checkClearQuota, trigger: 'change' }
        // ],
        remark: [
          { required: true, trigger: 'change', message: '请填写备注' }
        ]
      },
      labelPosition: 'right',
      lineType: '',
      warningLine: '',
      chargeLine: '',
      lineDialog: false,
      rules: {
        minBalanceLine: [
          { validator: minBalanceLine, trigger: 'blur' }
        ],
        maxCreditLine: [
          { pattern: /^(0|[1-9][0-9]*|-[1-9][0-9]*)$/, message: '请输入整数', trigger: 'blur' }
        ]
      },
      rulesSetCreditLine: {
        setCreditLine: [
          { pattern: /^(0|[1-9][0-9]*|-[1-9][0-9]*)$/, message: '请输入整数', trigger: 'blur' }
        ],
        line: [
          { pattern: /^(0|[1-9][0-9]*|-[1-9][0-9]*)$/, message: '请输入整数', trigger: 'blur' }
        ]
      },
      setCreditLineStoreId: '',
      setCreditLine: {
        setCreditLine: '',
        line: ''
      },
      dialogVisible: false,
      OffDialog: false,
      tipDialog: false,
      fullName: '',
      storeName: '',
      code: '',
      queryInfo: {
        total: 0,
        pageNum: 0,
        pageSize: 10
      },
      formInline: {
        maxCreditLine: '',
        minBalanceLine: '',
        salesmanId: '',
        storeId: '',
        code: ''
      },
      tableData: [],
      storeListByCode: [],
      storeListByName: [],
      salemanList: []
    }
  },
  created () {

  },
  destroyed () {
    // 销毁
    console.log('页面销毁')
    sessionStorage.removeItem('epayFlag')
  },
  async mounted () {
    if (sessionStorage.getItem('epayFlag') === 'true') {
      this.formInline = JSON.parse(sessionStorage.getItem('queryParams'))
      this.queryInfo = JSON.parse(sessionStorage.getItem('queryInfo'))
      this.storeListByCode = JSON.parse(sessionStorage.getItem('storeListByCode'))
      this.salemanList = JSON.parse(sessionStorage.getItem('salemanList'))

      sessionStorage.removeItem('epayFlag')
    } else {
      // 首次进入列表页,清除缓存中的搜索条件
      sessionStorage.removeItem('queryParams')
      sessionStorage.removeItem('queryInfo')
      sessionStorage.removeItem('storeListByCode')
      sessionStorage.removeItem('salemanList')
    }
    await this.getWarningLine('init')
    await this.onSubmit()
  },
  methods: {
    handleSizeChange (val) {
      this.queryInfo.pageSize = val
    },
    handleCurrentChange (val) {
      console.log(val)
      this.queryInfo.pageNum = val - 1
      this.changePage(this.queryInfo)
      // this.$emit('changePage', this.queryInfo)
    },
    updataLine () {
      // let line = Number(this.line)
      // if (!/^-?[1-9]\d*|0$/.test(line)) {
      //   this.$message.error('请输入正确的金额，小数点后最多两位')
      //   return
      // }
      this.$refs.formSetCreditLine.validate((validate) => {
        if (!validate) {
          console.log('进入', validate)
          return
        }
        adminConfigUpdate({ givenConfig: this.lineType, value: this.setCreditLine.line }).then(res => {
          if (res.data.success) {
            this.$message.success('设置成功')
            this.lineDialog = false
            this.setCreditLine.line = ''
            this.getWarningLine()
          }
        })
      })
    },
    selectSalemanList (val) {
      if (val.trim()) {
        getSalesmanByFullName(val).then(res => {
          if (res.data.success) {
            this.salemanList = res.data.data
          }
        })
      }
    },
    filterByName (val) {
      if (val.trim()) {
        storeQueryListByName(val).then(res => {
          if (res.data.success) {
            this.storeListByCode = res.data.data
          }
        })
      }
    },
    filterMethod (val) {
      if (val.trim()) {
        storeQueryListByCode(val).then(res => {
          if (res.data.success) {
            this.storeListByCode = res.data.data
          }
        })
      }
    },
    setLine () {
      console.log(this.setCreditLine.setCreditLine, '授信额度')
      if (this.setCreditLine.setCreditLine === '') {
        this.$message.error('请输入授信额度')
        return
      }
      if (this.setCreditLine.setCreditLine < 0) {
        this.$message.error('授信额度不能小于0')
        return
      }
      this.$refs.formSetCreditLine.validate((validate) => {
        if (!validate) {
          console.log('进入', validate)
          return
        }
        accountSetCreditLine({ storeId: +this.setCreditLineStoreId, creditLine: +this.setCreditLine.setCreditLine }).then(res => {
          if (res.data.success) {
            this.$message.success('更改成功')
            this.dialogVisible = false
            this.setCreditLine.setCreditLine = ''
            this.onSubmit()
          }
        })
      })
    },
    async getWarningLine (type) {
      await adminConfigGet('WARNING_LINE_ACCOUNT').then(res => {
        if (res.data.success) {
          this.warningLine = res.data.data.value
          if (this.$route.query.minBalanceLine) {
            this.formInline.minBalanceLine = this.warningLine
          }
          if (!type) this.onSubmit()
        }
      })
      await adminConfigGet('WARNING_LINE_CHARGE').then(res => {
        if (res.data.success) {
          this.chargeLine = res.data.data.value
        }
      })
    },
    updateWarningLine () {
      this.$refs.dialogRef.show('changeBalanceEq', '设置告急额度', this.warningLine, '', '告急额度', '告急额度')
    },
    onSubmit (num) {
      if (sessionStorage.getItem('epayFlag')) {
        sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
        sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
        sessionStorage.setItem('storeListByCode', JSON.stringify(this.storeListByCode))
        sessionStorage.setItem('salemanList', JSON.stringify(this.salemanList))
      }
      this.$refs.formName.validate((validate) => {
        if (!validate) {
          return
        }
        this.queryInfo.pageNum = num || this.queryInfo.pageNum
        console.log(this.formInline, 'this.formInline')
        getPlatListBySaleman({ data: this.formInline, params: { page: this.queryInfo.pageNum, size: this.queryInfo.pageSize } }).then(res => {
          if (res.data.success) {
            this.tableData = res.data.data.content
            this.queryInfo.total = res.data.data.total
          }
        })
      })
    },
    rowClassName ({ row, rowIndex }) {
      row.index = rowIndex
    },
    // 线下退款置空
    Empty () {
      this.formLabelAlign = {
        ACCT: '', // 当前余额
        BONUS: '', // 赠送余额
        amount: '', // 退款金额
        clearQuota: '', // 清空赠送额度
        remark: '', // 备注
        storeId: ''
      }
    },
    OffDialogCancel () {
      this.OffDialog = false
      this.Empty()
    },
    setOff (formNames) {
      if (!this.formLabelAlign.amount) {
        this.$message.error('退款金额不能为空')
        return
      }
      // if (this.formLabelAlign.clearQuota === '') {
      //   this.$message.error('清空礼金券额度不能为空')
      //   return
      // }
      if (this.formLabelAlign.remark === '') {
        this.$message.error('请填写备注')
        return
      }
      // this.formLabelAlign.clearQuota = this.formLabelAlign.BONUS
      this.$refs.formNames.validate((a) => {
        if (this.formLabelAlign.clearQuota > this.formLabelAlign.BONUS) {
          this.tipDialog = true
          return
        }
        if (this.formLabelAlign.amount > this.formLabelAlign.ACCT) {
          this.$message.error('退款金额不能大于当前余额')
          return
        }
        if (a) {
          let data = {
            amount: this.formLabelAlign.amount,
            remark: this.formLabelAlign.remark,
            bonus: this.formLabelAlign.BONUS,
            storeId: this.formLabelAlign.storeId,
            accountType: 'ACCT',
            originType: 'WEB',
            tradeMethod: 'REFUND_OFFLINE',
            channel: 'B2B'
          }
          this.loading = true
          addRefund(data).then(res => {
            console.log(res)
            if (res.data.success) {
              this.OffDialog = false
              this.$message.success('申请成功')
              this.loading = false
              this.Empty()
              this.onSubmit()
            }
          })
        }
      })
    },
    getStatus (val, content) {
      console.log(val, content)
      if (val === '余额明细') {
        sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
        sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
        sessionStorage.setItem('storeListByCode', JSON.stringify(this.storeListByCode))
        sessionStorage.setItem('salemanList', JSON.stringify(this.salemanList))
        this.$router.push({ path: '/epay/vpayAccountOrder', query: { store: JSON.stringify(content.store) } })
      }
      if (val === '更改授信额度') {
        this.dialogVisible = true
        this.setCreditLineStoreId = content.store.id
      }
      if (val === '提现') {
        sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
        sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
        sessionStorage.setItem('storeListByCode', JSON.stringify(this.storeListByCode))
        sessionStorage.setItem('salemanList', JSON.stringify(this.salemanList))
        this.$router.push({ path: '/epay/vpayWithdrawal', query: { store: JSON.stringify(content) } })
      }
      if (val === '线下退款') {
        console.log('线下退款')
        this.formLabelAlign.ACCT = content.balances.ACCT.balance
        this.formLabelAlign.BONUS = content.balances.BONUS.balance
        this.formLabelAlign.storeId = content.storeId
        this.OffDialog = true
      }
      this.setCreditLine.setCreditLine = content.standbyCreditLine
    },
    exportExcel () {
      const loading = this.$loading({
        lock: true,
        text: '正在导出表格，请稍后',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$refs.formName.validate((validate) => {
        if (!validate) {
          return
        }
        accountExport(this.formInline).then(res => {
          let blob = res.data
          const fileReader = new FileReader()
          fileReader.readAsDataURL(blob)
          fileReader.onload = (event) => {
            let a = document.createElement('a')
            let _fileName = '余额查询表' + this.$moment(new Date()).format('YYYY-MM-DD') + '.xls'
            a.download = _fileName
            a.href = event.target.result
            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
            loading.close()
          }
        })
      })
    },
    changelimit (val) {
      this.tableData[val.index].plateformPrice = val.message
    },
    clearSale () {
      this.fullName = ''
      this.formInline.salesmanId = ''
    },
    clear () {
      this.formInline.storeId = ''
      this.code = ''
      this.storeName = ''
    },
    handleSelect (item) {
      this.formInline.storeId = item.id
      this.code = item.code
      this.storeName = item.name
    },
    selectFullName (item) {
      this.formInline.salesmanId = item.id
    },
    changePage (val) {
      // val.pageNum -= 1
      this.queryInfo = val
      this.onSubmit()
    }
  }
}
</script>
<style scoped lang="less">
// @import "index";
.data-list .el-table tr td {
  height: 1.5rem !important;
}

@deep: ~">>>";

.vm-pagination {
  width: 100%;
  box-sizing: border-box;
  padding: 15px 0;
  display: flex;
  justify-content: center;

  @{deep}.el-pagination {
    .el-pager {
      li {
        background: #fff;
        min-width: 35px;
        height: 35px;
        line-height: 35px;
        border-radius: 3px;
        border: 1px solid #e4e4e4;
      }

      .active {
        background-color: #666666 !important;
        color: #fff;
      }
    }

    button {
      line-height: 35px;
      height: 35px;
    }

    .el-input--mini .el-input__inner,
    .el-pagination__jump {
      height: 35px;
      line-height: 35px;
    }
  }
}
</style>
